/**
 * Footer landing — colonnes liens + copyright.
 */
import { Link } from "react-router-dom";
import { colors, fonts, TAGLINE } from "../../styles/tokens";
import Logo from "../Logo";

export default function Footer() {
  return (
    <footer style={{
      padding: "60px clamp(16px, 4vw, 24px) 32px",
      background: colors.surface,
      borderTop: `1px solid ${colors.border}`,
      fontFamily: fonts.body,
      color: colors.textMuted,
      maxWidth: "100vw",
      overflowX: "hidden",
    }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div className="footer-grid" style={{
          display: "grid",
          gridTemplateColumns: "minmax(240px, 2fr) repeat(auto-fit, minmax(160px, 1fr))",
          gap: "32px 40px",
          paddingBottom: "40px",
          borderBottom: `1px solid ${colors.border}`,
        }}>
          {/* Colonne logo */}
          <div>
            <Logo size="sm" showName />
            <p style={{
              fontSize: "13px",
              lineHeight: 1.6,
              marginTop: "16px",
              maxWidth: 280,
            }}>
              La plateforme SaaS d'église pour les communautés chrétiennes francophones
              du monde entier.
            </p>
            <p style={{ fontSize: "13px", marginTop: "12px" }}>
              <a
                href="mailto:contact@mon-ministere.com"
                style={{ color: colors.gold, textDecoration: "none" }}
              >
                contact@mon-ministere.com
              </a>
            </p>
            <p style={{ fontSize: "13px", marginTop: "8px" }}>
              <a
                href="https://wa.me/33695215989?text=Bonjour%2C%20je%20souhaite%20en%20savoir%20plus%20sur%20Mon%20Minist%C3%A8re%20%F0%9F%99%8F"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#25D366", textDecoration: "none", fontWeight: 500 }}
              >
                💬 WhatsApp : +33 6 95 21 59 89
              </a>
            </p>
          </div>

          {/* Produit */}
          <FooterColumn
            title="Produit"
            links={[
              { label: "Fonctionnalités", href: "#fonctionnalites", scroll: true },
              { label: "Tarifs", href: "#tarifs", scroll: true },
              { label: "Nouveautés", href: "#" },
              { label: "Modules", href: "#fonctionnalites", scroll: true },
            ]}
          />

          {/* Ressources */}
          <FooterColumn
            title="Ressources"
            links={[
              { label: "Documentation", href: "#" },
              { label: "Tutoriels", href: "#" },
              { label: "Blog", href: "#" },
              { label: "Support", href: "mailto:contact@mon-ministere.com" },
            ]}
          />

          {/* Compte */}
          <FooterColumn
            title="Compte"
            links={[
              { label: "Se connecter", to: "/connexion" },
              { label: "Créer un compte", to: "/inscription" },
            ]}
          />
        </div>

        {/* Badges + copyright */}
        <div style={{
          paddingTop: "24px",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "16px",
          fontSize: "12px",
        }}>
          <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
            <span>🔒 RGPD</span>
            <span>🌍 88 pays</span>
            <span>🇫🇷 100% Français</span>
          </div>
          <div style={{ color: colors.textDim, fontSize: "12px" }}>
            © 2025 Mon Ministère ·{" "}
            <a href="#" style={{ color: colors.textMuted, textDecoration: "none" }}>CGU</a> ·{" "}
            <Link to="/confidentialite" style={{ color: colors.textMuted, textDecoration: "none" }}>
              Politique de confidentialité
            </Link>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .footer-grid {
            grid-template-columns: 1fr 1fr !important;
            gap: 24px 16px !important;
          }
          .footer-grid > div:first-child {
            grid-column: 1 / -1;
          }
        }
        @media (max-width: 480px) {
          .footer-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </footer>
  );
}

function FooterColumn({ title, links }) {
  return (
    <div>
      <h4 style={{
        color: colors.text,
        fontSize: "14px",
        fontWeight: 600,
        marginBottom: "14px",
        letterSpacing: "0.02em",
      }}>
        {title}
      </h4>
      <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: "8px" }}>
        {links.map((l) => (
          <li key={l.label}>
            {l.to ? (
              <Link to={l.to} style={footerLink}>{l.label}</Link>
            ) : (
              <a
                href={l.href}
                onClick={(e) => {
                  if (l.scroll) {
                    e.preventDefault();
                    document.getElementById(l.href.slice(1))?.scrollIntoView({ behavior: "smooth" });
                  }
                }}
                style={footerLink}
              >
                {l.label}
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

const footerLink = {
  color: colors.textMuted,
  fontSize: "13px",
  textDecoration: "none",
  transition: "color 150ms",
};
